import React from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { FileExplorerModalProps } from '../../../types/fileExplorerTypes';
import { deleteFolder, TreeFolder } from '../services';
import { ControlledAlertModal } from '../../common/ControlledModal';
import { useFileExplorerMutation } from '../../../hooks/useFileExplorerMutation';

const GENERIC_ERROR_MESSAGE = 'Ocurrió un error al eliminar la carpeta, por favor intenta nuevamente.';

export function DeleteFolderModal({ show, onHide, data }: FileExplorerModalProps<TreeFolder>) {
  if (!data) return null;

  const mutationFn = () => deleteFolder(data.id);
  const {
    mutateAsync, isLoading,
  } = useFileExplorerMutation({
    mutationFn,
    onSuccess: onHide,
  });

  const handleDelete = (id: string) => {
    const deletePromise = mutateAsync(id);
    toast.promise(deletePromise, {
      loading: 'Eliminando carpeta...',
      success: 'Carpeta eliminada exitosamente',
      error: {
        message: 'Error al eliminar la carpeta',
        description: GENERIC_ERROR_MESSAGE,
      },
    });
  };
  return (
    <ControlledAlertModal
      show={show}
      onHide={onHide}
      title="¿Está seguro/a?"
      description="Esta acción no se puede deshacer. Esto eliminará permanentemente la carpeta."
      closeButton
      centered
    >
      <Modal.Footer>
        <ControlledAlertModal.Actions
          handleClose={onHide!}
          onConfirm={() => handleDelete(data.id.toString())}
          isPending={isLoading}
        />
      </Modal.Footer>
    </ControlledAlertModal>
  );
}
